import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.1_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_typescript@5.8.3_vite@6.3.3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.1_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_typescript@5.8.3_vite@6.3.3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts")
}